export const formatDateTimeLocal = (date: Date) => `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${(date.getDate() + 1).toString().padStart(
        2,
        '0'
      )}T${date.getHours().toString().padStart(
        2,
        '0'
      )}:${date.getMinutes().toString().padStart(2, '0')}`